import React from 'react';

import { WordpressData } from '../../@types/Wordpress';
import { Archive } from '../Archive/Archive';
import { VRMSection } from '../VRMSection/VRMSection';

import styles from '../../WordpressPages.scss';

export type SidebarProps = {
  contentType: string;
  data: WordpressData | null;
};

export const Sidebar: React.FC<SidebarProps> = ({ contentType, data }) => {
  const showArchive = contentType === 'blog' && (data?.archive?.length ?? 0) > 0;

  return (
    <aside className={styles.sideBar} id="sidebar">
      <div className={styles.stickySidebar}>
        <VRMSection />
        {showArchive && <Archive archive={data!.archive!} />}
      </div>
    </aside>
  );
};
